import React,{ useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from "react-router-dom";
import { TableCell, TableRow } from '@mui/material';

import { getTransactionsRequest, createSettlement, getRequestStatus, getFixedCommissionFeesRequest } from '../../../../../store/OutstandingBalance/actions';
import { SettlementsIcon } from '../../../../../utils/Icons'
import { ROUTE_PATHS } from '../../../../../utils/RoutesPaths';
import { renderTextEllipsis } from "../../../../../utils/Helpers";
import { getYearMonthFromDate } from "../../../../../utils/DateHelpers";
import messages from '../../../../../assets/locale/messages';
import EmptyState from '../../../../../components/EmptyState';
import Table from '../../../../../components/Table';
import Pagination from '../../../../../components/Pagination';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal'
import './Transaction.scss'

const Transactions = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { id } = useParams();
    const lang = useSelector((state) => state.locale.lang);
    const isLoading = useSelector((state) => state.loader);
    const transactionsList = useSelector((state) => state.outstandingBalance.transactions);
    const fixedCommissionFeesList = useSelector((state) => state.outstandingBalance.fixedCommissionFees);
    const meta = useSelector((state) => state.outstandingBalance.transactionsMeta);
    const fixedCommissionFeesMeta = useSelector((state) => state.outstandingBalance.fixedCommissionFeesMeta);
    const settlementConfirmationData = useSelector((state) => state.outstandingBalance.settlementConfirmationData);
    const requestStatus = useSelector((state) => state.outstandingBalance.requestStatus);
    const { outStandingBalance, shared } = messages[lang];
    const [page, setPage] = useState(1);
    const [fixedCommissionFeesPage, setFixedCommissionFeesPage] = useState(1);
    const [showSettlePopup, setShowSettlePopup] = useState(false);

    useEffect(()=>{
        dispatch(getTransactionsRequest({
            service_provider_id:id,
            page:page,
            items:10
        }))
    },[page]);

    useEffect(()=>{
        setPage(1)
        dispatch(getTransactionsRequest({
            service_provider_id:id,
            page:1,
            items:10
        }))
    },[lang]);

    useEffect(()=>{
        setPage(1)
        dispatch(getTransactionsRequest({
            service_provider_id:id,
            page:1,
            items:10
        }))
    },[requestStatus]);

    useEffect(()=>{
        setFixedCommissionFeesPage(1) 
        dispatch(getFixedCommissionFeesRequest({
            service_provider_id:id,
            is_settled:false,
            page:fixedCommissionFeesPage,
            items:10
        }))
    },[fixedCommissionFeesPage, requestStatus]); 

    const renderSettlePopupContent = () => (
        <div className="fsize-18">
            <div>{outStandingBalance.transactions.serviceProvider}: 
                <span className="text-gray"> {settlementConfirmationData.service_provider_name}</span>
            </div>
            <div>{outStandingBalance.transactions.settlementStatus}:
                <span className="text-gray"> {settlementConfirmationData.settlement_status}</span>
            </div>
            <div>{outStandingBalance.transactions.settlementAmount}:
                <span className="text-gray"> {settlementConfirmationData.outstanding_balance}</span>
            </div>
        </div>
    );

    const handleSettle = () => {
        dispatch(createSettlement({
            service_provider_id: id
        }));
        dispatch(getRequestStatus(false));
        setShowSettlePopup(false);
    };

    const renderTransactionsList = () => {
        if(!isLoading && transactionsList?.length === 0){
            return(
                <div className="bg-white rounded-4 categoriess-page d-flex justify-content-center align-items-center flex-column">
                    <EmptyState
                    subTitle={outStandingBalance.transactions.emptyState}
                    showActionButton={false}
                    NoDataListWithNoActionBtn={true}
                    />
              </div>
            )
        }else{
            return(
                <div className="bg-white rounded-4 mx-4 transactions-table-list">
                  <Table
                  className="bg-light-blue"
                    headlines={[
                      outStandingBalance.transactions.appointmentNumber,
                      outStandingBalance.transactions.branchName,
                      outStandingBalance.transactions.date,
                      outStandingBalance.transactions.paidAmount,
                      outStandingBalance.transactions.settlementAmount,
                      outStandingBalance.transactions.paymentType
                    ]}
                    rows={transactionsList?.map((row, i) => (
                      <TableRow key={i}>
                        {/* Appointment number */}
                        <TableCell className="font-regular text-dark-blue fsize-14">
                          <div
                            className="pointer appoinment-id-contanier"
                            onClick={()=>{history.push(ROUTE_PATHS.viewBooking.replace(':id', row.appointment.id))}}
                          >
                            {row.appointment.appointment_number}
                          </div>
                        </TableCell>
                        {/* Branch name */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {lang === 'en' 
                            ? renderTextEllipsis(row.branch_name_en)
                            : renderTextEllipsis(row.branch_name_ar)
                          }
                        </TableCell>
                        {/* Date */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {row.date}
                        </TableCell>
                        {/* Paid amount */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {row.paid_amount}
                        </TableCell>
                        {/* Settlement amount */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {row.settlement_amount}
                        </TableCell>
                        {/* payment type */}
                        <TableCell className="font-regular text-dark-blue fsize-14 ">
                          {outStandingBalance.details[row.transaction_type]}
                        </TableCell>
                      </TableRow>
                    ))}
                  />
                  <div className="d-flex justify-content-center py-3">
                    {meta?.pages > 1 && (
                      <Pagination
                        count={meta?.pages}
                        page={meta?.currentPage || page}
                        handleChange={(event, page) => {
                        setPage(page);
                         }}
                        defaultPage={1}
                      />
                    )} 
                  </div>
                </div>
            )
        }

    };

    const renderFixedCommissionFeesList = () => {
      if(!isLoading && fixedCommissionFeesList?.length === 0){
          return(
              <div className="bg-white rounded-4  p-2 categoriess-page d-flex justify-content-center align-items-center flex-column mt-5">
                  <EmptyState
                  subTitle={outStandingBalance.fixedCommissionFees.emptyState}
                  showActionButton={false}
                  NoDataListWithNoActionBtn={true}
                  />
            </div>
          )
      }else{
          return(
              <div className="bg-white rounded-4 p-2 transactions-table-list mt-5">
                <div className="rounded-4 fsize-24 fweight-600 text-primary m-3">
                {outStandingBalance.fixedCommissionFees.pageTitle}
                </div>
                <div className="px-4">
                <Table
                className="bg-light-blue  rounded-4"
                  headlines={[
                    outStandingBalance.fixedCommissionFees.month,
                    outStandingBalance.fixedCommissionFees.amount
                  ]}
                  rows={fixedCommissionFeesList?.map((row, i) => (
                    <TableRow key={i}>
                      {/* Month */}
                      <TableCell className="font-regular text-dark-blue fsize-14">
                          {getYearMonthFromDate(row.date)}
                      </TableCell>
                      {/* Amount */}
                      <TableCell className="font-regular text-dark-blue fsize-14 ">
                        {row.amount}
                      </TableCell>
                    </TableRow>
                  ))}
                />
                <div className="d-flex justify-content-center py-3">
                  {fixedCommissionFeesMeta?.pages > 1 && (
                    <Pagination
                      count={fixedCommissionFeesMeta?.pages}
                      page={fixedCommissionFeesMeta?.currentPage || fixedCommissionFeesPage}
                      handleChange={(event, page) => {
                      setFixedCommissionFeesPage(page);
                       }}
                      defaultPage={1}
                    />
                  )} 
                </div>
                </div>
              </div>
          )
      }

  };

    return(
        <div className="transactions-page">
          <div className="bg-white rounded-4 p-2">
            <div className="rounded-4 fsize-24 fweight-600 text-primary m-3 ">
                {outStandingBalance.transactions.pageTitle}
                <div className="fsize-16 fweight-500 d-flex justify-content-between align-items-center mt-4 mx-3 mb-2">
                   <span className="">{outStandingBalance.transactions.outstandingBalance}: {settlementConfirmationData.outstanding_balance} {outStandingBalance.transactions.sr}</span> 
                    {settlementConfirmationData.outstanding_balance != 0 && (
                        <Button
                            label={<div className="d-flex gap-2 px-4">
                                        <div><SettlementsIcon /></div>
                                        <div>{outStandingBalance.transactions.settle}</div>
                                    </div>
                                  }
                            labelClass="text-white fsize-18 fweight-500"
                            onClick={() => {setShowSettlePopup(true)}}
                            
                        />
                    )}
                </div>
            </div>
            {renderTransactionsList()}
          </div>
            {renderFixedCommissionFeesList()}
            <Modal
                open={showSettlePopup}
                handleClose={()=>{setShowSettlePopup(false)}}
                title={<span className="fsize-28 fweight-400">{outStandingBalance.transactions.settlementConfirmation}</span>}
                contentClass="mb-2 pb-2 text-primary"
                content={renderSettlePopupContent()}
                confirmBtnTxt={outStandingBalance.transactions.settle}
                cancelBtnTxt={shared.cancel}
                isContentText={false}
                handleConfirm={handleSettle}
                handleCancel={()=>{setShowSettlePopup(false)}}
                maxWidth="sm"
                actionsClass=" px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 px-5"
                cancelBtnClass="fsize-14 py-2 text-secondary px-5 "
            />
        </div>
    )
}

export default Transactions;